import {
  StatTableComponent
} from './stat-table.component';
import {
  SummStatComponent
} from './summ-stat/summ-stat.component';
import {
  scCoreModule
} from '../core/core.module';
import {
  PieComponent
} from './pie.component';
import {
  TreeComponent
} from './tree.component';
import {
  TreeService
} from './tree.service';
import {
  ChartComponent
} from './chart.component';
import {
  RadarComponent
} from './radar/radar.component';
import {
  EventRiverComponent
} from './event-river/event-river.component';
import {
  StatHeaderComponent
} from './stat-header/stat-header.component';
import {
  ContextMenuComponent
} from './context-menu/context-menu.component';

export const scStatModule = 'sc-stat';

angular.module(scStatModule, [scCoreModule])
  .service('TreeService', TreeService)
  .component('scStatTable', StatTableComponent)
  .component('scSummStat', SummStatComponent)
  .component('scPie', PieComponent)
  .component('scChart', ChartComponent)
  .component('scRadar', RadarComponent)
  .component('scEventRiver', EventRiverComponent)
  .component('scTree', TreeComponent)
  .directive('scContextMenu', ContextMenuComponent)
  .directive('scStatHeader', StatHeaderComponent);



// WEBPACK FOOTER //
// ./src/stat/stat.module.js